import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, typography, color } from 'styled-system';

const Div = styled.div`
  ${space}
  ${typography}
  ${color}
`;

const Block = ({ children, ...props }) => {
  return <Div {...props}>{children}</Div>;
};

Block.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Block;
